import axios from 'axios';
import { API_CONFIG } from '../utils/apiConfig.js';
import { mobileConfig } from '../utils/mobileUtils.js';

const API_BASE_URL = API_CONFIG.BASE_URL ? `${API_CONFIG.BASE_URL}/api/v1` : '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: mobileConfig.requestTimeout || API_CONFIG.TIMEOUT,
  withCredentials: false,
  headers: {
    ...API_CONFIG.DEFAULT_HEADERS,
    'Cache-Control': 'no-cache'
  },
});

// Request interceptor - adiciona token do localStorage aos headers
api.interceptors.request.use(
  config => {
    const accessToken = localStorage.getItem('accessToken');
    
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      console.log('✅ [API INTERCEPTOR] Token adicionado para:', config.url);
    } else {
      console.warn('⚠️ [API INTERCEPTOR] Nenhum token encontrado para:', config.url);
    }
    
    return config;
  },
  error => {
    console.error('❌ [API INTERCEPTOR] Erro no interceptor:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for token refresh
api.interceptors.response.use(
  response => {
    if (response.data?.accessToken) {
      localStorage.setItem('accessToken', response.data.accessToken);
    }
    if (response.data?.refreshToken) {
      localStorage.setItem('refreshToken', response.data.refreshToken);
    }
    return response;
  },
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && 
        !originalRequest._retry && 
        !originalRequest.url?.includes('/auth/logout') &&
        !originalRequest.url?.includes('/auth/refresh')) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          throw new Error('No refresh token');
        }

        const response = await axios.post(`${API_BASE_URL}/auth/refresh`, 
          { refreshToken },
          { withCredentials: false }
        );

        const { accessToken, refreshToken: newRefreshToken } = response.data;
        localStorage.setItem('accessToken', accessToken);
        if (newRefreshToken) {
          localStorage.setItem('refreshToken', newRefreshToken);
        }

        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default api;